export default __webpack_public_path__ + "static/B0212-c9e49aa70fa189499ed6aef1a0ebb669.png";